import { MutableRefObject, useRef, useState } from 'react';

import dateService from '@gem/services/date-service';

interface IDatePickerReturnType {
  presenter: IDatePickerPresenter;
  anchorRef: MutableRefObject<HTMLButtonElement | null>;
}

interface IDatePickerPresenter {
  isPickerOpen: boolean;
  onSwitchPicker(): void;
  onChange(date: Date): void;
  formatedTitle: string;
  value: Date;
}

interface IDatePickerPresenterProps {
  value: Date;
  onChange(date: Date): void;
}

export function useDatePickerPresenter(props: IDatePickerPresenterProps): IDatePickerReturnType {
  const [isPickerOpen, setPickerOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement | null>(null);

  const presenter: IDatePickerPresenter = {
    isPickerOpen,
    value: props.value,

    onSwitchPicker(): void {
      setPickerOpen((prev) => !prev);
    },

    onChange(date: Date): void {
      props.onChange(date);
      presenter.onSwitchPicker();
    },

    get formatedTitle(): string {
      return (
        dateService.format(presenter.value, {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        }) || ''
      );
    },
  };

  return { presenter, anchorRef };
}
